import { FC } from "react"
import Image from "next/image"
import classNames from "classnames"
import { readImage } from "../../app/utils/read-image"
import { BlokImage } from "../../storyblok"
import { safelyRenderHtml } from "@/util/safelyRenderHtml"
import { useGeoDataEffect } from "../../hooks/useGeoData"
import { PremiumHeroForm } from "./hero-form"
import useScreenSize from "@/hooks/useScreenSize"

export interface IPetsHeroATF {
  blok: {
    title: string
    description: string
    buttonLink?: string
    buttonLabel?: string
    image?: BlokImage
    bgSmImage?: BlokImage
    geoPostDescription?: string
    geoTitle?: string
    hasGeoCustomization?: boolean
    hasSwapCustomization?: boolean
    hasListingForm?: boolean
    animalType?: string
    bgImagePlacement?: string
  }
}
const PetsHeroATF: FC<IPetsHeroATF> = (props) => {
  const {
    title,
    description,
    buttonLabel,
    buttonLink,
    bgSmImage,
    image,
    hasGeoCustomization = false,
    hasSwapCustomization = false,
    geoPostDescription = "Hire top-rated transporters in {location}.",
    geoTitle = "",
    hasListingForm = false,
  } = props.blok
  const showOnDesktop = useScreenSize({ min: "md" })
  const { geoDescription, geoSessionValue } = useGeoDataEffect(
    geoPostDescription,
  )
  const geoLocationTitle = useGeoDataEffect(geoTitle)

  return (
    <>
      <section
        id="hero-section"
        className={classNames(
          "relative lg:flex md:h-[645px] bg-secondary-100 mx-auto justify-center md:pt-8",
        )}
      >
        <div className="w-full md:w-1/2 lg:w-2/3 lg:max-w-[651px]">
          <div
            className={`h-[385px] md:h-full relative max-w-4xl lg:max-w-5xl xl:max-w-7xl mx-auto px-6 lg:px-8 py-8`}
          >
            <div className="text-black font-inter max-w-3xl text-left md:mt-10 lg:mt-20 mb-0">
              <h1 className="text-5xl leading-[72px] sm:text-[42px] md:text-[56px] font-bold lg:text-[56px] mt-1 md:mt-4 mb-6">
                {geoLocationTitle.geoDescription && geoLocationTitle.isUSVisitor
                  ? geoLocationTitle.geoDescription
                  : title}
              </h1>
              <p
                id="PremiumHero-description"
                className="text-lg leading-10 max-w-lg font-inter"
              >
                {safelyRenderHtml(
                  `${description} ${
                    hasGeoCustomization ? geoDescription : ""
                  } `,
                )}
              </p>
            </div>
          </div>
        </div>
        <div
          className={classNames(
            "w-full  md:w-1/2 lg:w-1/3",
            !showOnDesktop && "hidden",
          )}
        >
          {image && (
            <Image
              src={readImage(image)}
              alt={image.alt || "hero image"}
              width={492}
              height={428}
              objectFit="cover"
              objectPosition="center"
              className={classNames(
                "w-[435px] h-[378px] md:w-[492px] md:h-[428px] order-first md:order-last mb-12 md:mb-0 object-cover object-center",
                bgSmImage?.filename ? "hidden md:block" : "block",
              )}
            />
          )}
        </div>
        <div
          className={classNames(
            "relative lg:absolute lg:-bottom-24 max-w-7xl mx-auto md:flex justify-center bg-white rounded-1 px-6 md:px-5 lg:px-8 py-11 right-0 left-0",
            hasListingForm ? "md:h-[300px]" : "md:h-[240px]",
          )}
        >
          <div>
            <PremiumHeroForm
              buttonLabel={buttonLabel}
              buttonLink={buttonLink}
              hasSwapCustomization={hasSwapCustomization}
              geoSessionValue={geoSessionValue as string}
              hideLabel
              font="font-inter"
            />
          </div>
        </div>
      </section>
      <div className={classNames("", showOnDesktop && "hidden")}>
        {image && (
          <Image
            src={readImage(image)}
            alt={image.alt || "hero image"}
            width={492}
            height={428}
            objectFit="cover"
            objectPosition="center"
            className={classNames(
              "w-[435px] h-[378px] md:w-[492px] md:h-[428px] order-first md:order-last mb-12 md:mb-0 object-cover object-center",
              bgSmImage?.filename ? "hidden md:block" : "block",
            )}
          />
        )}
        {bgSmImage && (
          <Image
            className="sm:hidden"
            src={readImage(bgSmImage ?? image)}
            alt={bgSmImage.alt || "hero image"}
            layout="fill"
            objectFit="cover"
            objectPosition="center"
          />
        )}
      </div>
      <section className="md:mb-10" />
    </>
  )
}
export default PetsHeroATF
